import { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import BookDetail from '@/components/screens/book-detail/BookDetail';
import { API_URL } from '@/helpers/variables';
import { IReviews } from '@/interfaces/reviews.interface';
import { IBookShortDetail } from '@/interfaces/bookShortDetail.interface';

interface IBookDetailPage {
  book: IBookShortDetail;
  reviews: IReviews;
  aldebaranUrl: { url: string };
}

const BookDetailPage: NextPage<IBookDetailPage> = ({ book, reviews, aldebaranUrl }) => {
  return <BookDetail book={book} reviews={reviews} aldebaranUrl={aldebaranUrl} />;
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { id } = context.query;

  const [bookRes, reviewsRes] = await Promise.all([fetch(`${API_URL}satellite/books/fenzin/${id}`), fetch(`${API_URL}satellite/reviews/?book_id=${id}&page=1&page_size=5`)]);

  if (bookRes.status === 404) {
    const errorResponse = await bookRes.json();
    const redirectUrl = errorResponse.detail?.url;

    if (redirectUrl) {
      return {
        redirect: {
          destination: redirectUrl,
          permanent: true,
        },
      };
    }
  }

  // Check fetch error
  if (!bookRes.ok) {
    console.table(`Error ${bookRes.status}. Api: ${bookRes.url}`);
    return {
      notFound: true,
    };
  }

  const [book, reviews] = await Promise.all([bookRes.json(), reviewsRes.json()]);

  // Check Fetched Data Error
  if (!book.id) {
    return {
      notFound: true,
    };
  }

  const aldebaranUrlRes = await fetch(`${API_URL}aldebaran_url/${book.book.id}`);
  const aldebaranUrl = await aldebaranUrlRes.json();

  return { props: { book, reviews, aldebaranUrl } };
};

export default BookDetailPage;
